/*
  API configuration
  To be set by script before build + deploy
*/
export const API_KEY = "DPWMFU3To1FSJFmctxm412WUIzsjB8pt";
export const API_BASE_URL = "https://touchpointsdiaryapi-python-dev.intrasonics.com";
